import { Model } from "vue-mc";

export class Talento extends Model {
  defaults() {
    return {
      clave: null
      , nombre: ""
      , email: ""
      , linkedin: ""
      , pais: null
      , provincia: null
      , localidad: null
      , contacto: ""
      , moneda: ""
      , rangoSalarial: ""
      , sueldoPretendido: 0.0
      , sueldoNegociado: 0.0
      , tipoSalario: ""
      , disponibilidad: ""
      , cv: false
      , origencv: ""
      , cvnxn: false
      , reclutadores: ""
      , calificacion: 0
      , seniority: null
      , status: 0
      , observaciones: ""
      , observacionesgen: ""
      , fechaCambioEstatus: ""
      , fechaUltimoContacto: ""
      , fechaContratacion: ""
      , fechaBaja: ""
      , perfiles: []
      , clientes: []
      , habilidades: []
      , telefonos: []
      , usuarios: []
      , idiomas: []
      , adjuntos: ""
      , video: ""
      , foto: ""
      , titulouni: ""
      , mailPCCounter: 0
      , version: 0
    };
  }

  mutations() {
    return {
      clave: (clave) => clave
      , nombre: (nombre) => nombre
      , email: (email) => email
      , linkedin: (linkedin) => linkedin
      , pais: (pais) => pais
      , provincia: (provincia) => provincia
      , localidad: (localidad) => localidad
      , contacto: (contacto) => contacto
      , moneda: (moneda) => moneda
      , rangoSalarial: (rangoSalarial) => rangoSalarial
      , sueldoPretendido: (sueldoPretendido) => sueldoPretendido
      , sueldoNegociado: (sueldoNegociado) => sueldoNegociado
      , tipoSalario: (tipoSalario) => tipoSalario
      , disponibilidad: (disponibilidad) => disponibilidad
      , cv: (cv) => cv
      , origencv: (origencv) => origencv
      , cvnxn: (cvnxn) => cvnxn
      , reclutadores: (reclutadores) => reclutadores
      , calificacion: (calificacion) => calificacion
      , seniority: (seniority) => seniority
      , status: (status) => status
      , observaciones: (observaciones) => observaciones
      , observacionesgen: (observacionesgen) => observacionesgen
      , fechaCambioEstatus: (fechaCambioEstatus) => fechaCambioEstatus
      , fechaUltimoContacto: (fechaUltimoContacto) => fechaUltimoContacto
      , fechaContratacion: (fechaContratacion) => fechaContratacion
      , fechaBaja: (fechaBaja) => fechaBaja
      , perfiles: (perfiles) => perfiles
      , clientes: (clientes) => clientes
      , habilidades: (habilidades) => habilidades
      , telefonos: (telefonos) => telefonos
      , usuarios: (usuarios) => usuarios
      , idiomas: (idiomas) => idiomas
      , adjuntos: (adjuntos) => adjuntos
      , video: (video) => video
      , foto: (foto) => foto
      , titulouni: (titulouni) => titulouni
      , mailPCCounter: (mailPCCounter) => mailPCCounter
      , version: (version) => version
    };
  }

  validation() {
    return {};
  }

  options() {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/models/talento.js